// TAKE5 - 5 Minute Burnout Workouts for Basic Tier
// Quick, effective workouts that can be done anytime, anywhere
const basicWorkouts = [
  {
    id: 'take5-warmup',
    name: 'Warm Up',
    tier: 'basic',
    duration: 5,
    level: 'Beginner',
    focusArea: 'Full Body',
    description: 'Essential 5-minute warm-up to prepare your body for exercise',
    thumbnailUrl: '/images/thumbnails/take5-warmup-thumbnail.svg',
    videoId: '0cc7cdb238099c37b1fcecdbd4d30351',
    platform: 'cloudflare',
    type: 'video',
    focusAreas: ['Warm Up', 'Mobility', 'Preparation']
  },
  {
    id: 'take5-lower',
    name: 'Lower Focus',
    tier: 'basic',
    duration: 5,
    level: 'Beginner',
    focusArea: 'Legs',
    description: '5-minute lower body burnout - target your legs, glutes, and lower body strength',
    thumbnailUrl: '/images/thumbnails/take5-lower-thumbnail.svg',
    videoId: '7b527565efe657dfc9e6fdf2b5049f0e',
    platform: 'cloudflare',
    type: 'video',
    focusAreas: ['Legs', 'Glutes', 'Lower Body']
  },
  {
    id: 'take5-upper',
    name: 'Upper Focus',
    tier: 'basic',
    duration: 5,
    level: 'Beginner',
    focusArea: 'Upper Body',
    description: '5-minute upper body burnout - strengthen your arms, shoulders, and upper body',
    thumbnailUrl: '/images/thumbnails/take5-upper-thumbnail.svg',
    videoId: '52d1fe6a887c48a6f7e387d3d9e02ce4',
    platform: 'cloudflare',
    type: 'video',
    focusAreas: ['Arms', 'Shoulders', 'Upper Body']
  },
  {
    id: 'take5-core',
    name: 'Core Focus',
    tier: 'basic',
    duration: 5,
    level: 'Beginner',
    focusArea: 'Core',
    description: '5-minute core burnout - build core strength and stability',
    thumbnailUrl: '/images/thumbnails/take5-core-thumbnail.svg',
    videoId: '032b1b31c53890c0929e15e421226da7',
    platform: 'cloudflare',
    type: 'video',
    focusAreas: ['Core', 'Abs', 'Stability']
  },
  {
    id: 'take5-total',
    name: 'Total Body',
    tier: 'basic',
    duration: 5,
    level: 'Beginner',
    focusArea: 'Full Body',
    description: '5-minute total body burnout - full body workout for overall strength',
    thumbnailUrl: '/images/thumbnails/take5-total-thumbnail.svg',
    videoId: '76a6fa9e036961b6307f5e24ca1688ba',
    platform: 'cloudflare',
    type: 'video',
    focusAreas: ['Full Body', 'Strength', 'Endurance']
  },
  {
    id: 'take5-booty',
    name: 'Booty Burnout',
    tier: 'basic',
    duration: 5,
    level: 'Beginner',
    focusArea: 'Glutes',
    description: '5-minute booty burnout - target and strengthen your glutes',
    thumbnailUrl: '/images/thumbnails/take5-booty-thumbnail.svg',
    videoId: '6176ad4f1166ee1c9da046ed8ba349dd',
    platform: 'cloudflare',
    type: 'video',
    focusAreas: ['Glutes', 'Lower Body', 'Strength']
  }
];

export { basicWorkouts };
